import { object, string } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';

const validateSchema = object().shape({
  stepNum: textValidator({ fieldName: 'stepNum' }),
  stepCodeExt: textValidator({ fieldName: 'stepCodeExt' }),
  stepType: textValidator({ fieldName: 'stepType' }),
  stepName: textValidator({ fieldName: 'stepName' }),
  stepDesc: textValidator({ fieldName: 'stepDesc' }),
  textSuccess: textValidator({ fieldName: 'textSuccess' }),
  textFailLt: textValidator({ fieldName: 'textFailLt' }),
  textFailGt: textValidator({ fieldName: 'textFailGt' }),
  textFailEq: textValidator({ fieldName: 'textFailEq' }),
  premise: textValidator({ fieldName: 'premise', required: false }).test(
    'premise',
    'Поле должно быть заполнено',
    (value, { parent: { cond } }) => {
      if (cond) return !!value;
      return true;
    },
  ),
  formula: textValidator({ fieldName: 'formula' }),
  ctrlType: textValidator({ fieldName: 'ctrlType', required: false }),
  decimalQty: string().when('roundingType', {
    is: (v) => v !== null && v !== undefined,
    then: string().nullable().required(),
    otherwise: string().nullable().notRequired(),
  }),
});

export const validate = createValidator(validateSchema);
